import { i18n } from "./../../../plugins/vue-i18n";

const validateNaturalPersonLastName = {
  validate: validate,
  message: i18n.t("VALIDATION_ERRORS.validateNaturalPersonLastName")
};

function validate(input) {
  return input.length >= 3;
}

export default validateNaturalPersonLastName;
